export default __webpack_public_path__ + "static/media/CompaniesOnApp.6d793d1c.png";